export const REQUEST_WORD_PREDICTIONS_DATA = "REQUEST_WORD_PREDICTIONS_DATA";
export const RECEIVE_WORD_PREDICTIONS_DATA = "RECEIVE_WORD_PREDICTIONS_DATA";
export const REQUEST_FOLDER_PREDICTIONS_DATA = "REQUEST_FOLDER_PREDICTIONS_DATA";
export const RECEIVE_FOLDER_PREDICTIONS_DATA = "RECEIVE_FOLDER_PREDICTIONS_DATA";
export const SET_SEGMENT_RULES_DATA = "SET_SEGMENT_RULES_DATA";
export const REQUEST_SEGMENTS_PREVIEW_DATA = "REQUEST_SEGMENTS_PREVIEW_DATA";
export const SET_SHOW_WIZARD_TIPS = "SET_SHOW_WIZARD_TIPS";
export const RESET_SEGMENTS_WIZARD_DATA = "RESET_SEGMENTS_WIZARD_DATA";
export const SET_SEGMENTS_READY = "SET_SEGMENTS_READY";
